/* eslint-disable no-param-reassign */
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  state: {
    user: null,
    isUserModalOpened: false,
    isConfirmModalOpened: false,
    isParamModalOpened: false,
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    OnLoginUser(state, payload) {
      state.user = payload.email;
    },
    openUserModal(state) {
      state.isUserModalOpened = true;
    },
    closeUserModal(state) {
      state.isUserModalOpened = false;
    },
    openConfirmModal(state) {
      state.isConfirmModalOpened = true;
    },
    closeConfirmModal(state) {
      state.isConfirmModalOpened = false;
    },
    openParamModal(state) {
      state.isParamModalOpened = true;
    },
    closeParamModal(state) {
      state.isParamModalOpened = false;
    },
  },
  actions: {
    async registerUser({ commit }, { email, password }) {
      commit('clearError');
      commit('setLoading', true);

      try {
        const cred = await firebase.auth().createUserWithEmailAndPassword(email, password);
        commit('setLoading', false);
        commit('closeUserModal');
      } catch (error) {
        commit('setLoading', false);
        commit('setError', error.message);
      }
    },
    async loginUser({ commit }, { email, password }) {
      commit('clearError');
      commit('setLoading', true);

      try {
        const cred = await firebase.auth().signInWithEmailAndPassword(email, password);
        commit('setLoading', false);
        commit('closeUserModal');
      } catch (error) {
        commit('setLoading', false);
        commit('setError', error.message);
      }
    },
    makeLogOut({ commit }) {
      firebase.auth().signOut();
      commit('setUser', null);
      commit('closeConfirmModal');
      commit('setUserMessage', 'Du bist von deinem Konto abgemeldet.');
    },
  },
  getters: {
    login(state) {
      return state.user;
    },
    modal(state) {
      return state.isUserModalOpened;
    },
    confirmModal(state) {
      return state.isConfirmModalOpened;
    },
    paramModal(state) {
      return state.isParamModalOpened;
    },
  },
};
